<template>
  <validation-observer ref="simpleRules">
    <b-row>
      <!-- Gender -->
      <b-col cols="12">
        <b-form-group
          label-for="input-gender"
          label-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.gender.title"
              :description="labelForm.gender.description"
            />
          </template>
          <validation-provider
            #default="{ errors }"
            name="gender"
            rules="required"
          >
            <b-form-select
              v-model="form.gender"
              :options="[
                { value: 'male', text: 'Laki-laki' },
                { value: 'female', text: 'Perempuan' },
                { value: 'any', text: 'Semua Jenis Kelamin' },
              ]"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- Mulai dari usia -->
      <b-col cols="12">
        <b-form-group
          label-for="input-start-age"
          label-cols-md="4"
          content-cols-md="6"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.age.title"
              :description="labelForm.age.description"
            />
          </template>
          <b-row
            align-v="center"
            align-h="center"
          >
            <b-col>
              <validation-provider
                #default="{ errors }"
                name="Usia Minimal"
              >
                <b-input-group append="Bulan">
                  <cleave
                    id="input-start-age"
                    v-model="form.min_age"
                    class="form-control"
                    :class="{'is-invalid' : false}"
                    :raw="true"
                    :options="options.number"
                    placeholder="Dari usia"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              xl="auto"
              md="12"
              class="p-0"
            >
              <feather-icon
                size="18"
                icon="MinusIcon"
                class="d-none d-sm-block"
              />
              <div class="mt-2 d-block d-sm-none" />
            </b-col>
            <b-col>
              <validation-provider
                #default="{ errors }"
                rules="min_value:@Usia Minimal"
                name="Usia Maksimal"
              >
                <b-input-group append="Bulan">
                  <cleave
                    id="input-end-age"
                    v-model="form.max_age"
                    class="form-control"
                    :class="{'is-invalid' : false}"
                    :raw="true"
                    :options="options.number"
                    placeholder="Hingga usia"
                  />
                </b-input-group>
                <small class="text-danger position-absolute">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import {
  BCol,
  BFormGroup,
  BFormSelect,
  BInputGroup,
  BRow,
} from 'bootstrap-vue'

import Cleave from 'vue-cleave-component'

// Quill Editor
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

// Vee Validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

import { mapState, mapGetters, mapActions } from 'vuex'

import FormLabel from '@/layouts/components/custom/FormLabel.vue'

export default {
  name: 'ProductRecomendationForm',
  components: {
    BCol,
    BFormGroup,
    BFormSelect,
    BInputGroup,
    BRow,
    ValidationProvider,
    ValidationObserver,
    Cleave,
    FormLabel,
  },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSearchingMerchant: false,
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: ',',
          delimiter: '.',
          numeralPositiveOnly: true,
        },
      },
      required,
    }
  },
  computed: {
    ...mapState('merchant', ['merchants']),
    ...mapState('products', ['labelForm']),
    ...mapGetters('category', ['categoryList']),
  },
  async mounted() {
    // await this.getCategoryList()
  },
  methods: {
    ...mapActions('merchant', ['getMerchantList']),
    ...mapActions('category', ['getCategoryList']),
    async validationForm() {
      const response = await this.$refs.simpleRules.validate()
      return response
    },
    async onSearchMerchant(text) {
      this.isSearchingMerchant = true
      await this.getMerchantList({ keyword: text })
      this.isSearchingMerchant = false
    },
  },
}
</script>
